<mat-toolbar color="primary">
  <mat-toolbar-row>
    <a mat-icon-button routerLink="../../rosters">
      <mat-icon>arrow_back</mat-icon>
    </a>
    @if (roster) {
    <span class="branding">
      {{ roster.name }}
    </span>
    }
    <span class="spacer"></span>
  </mat-toolbar-row>
</mat-toolbar>

<mat-tab-group backgroundColor="primary" color="primary" mat-stretch-tabs="false">

  <mat-tab label="Divisions">
    <ng-template mat-tab-label>
      Divisions
    </ng-template>

    <ng-template matTabContent>
      <app-division-grid [roster]="roster"></app-division-grid>
    </ng-template>
  </mat-tab>

  <mat-tab label="Assignments">
    <ng-template mat-tab-label>
      Assignments
    </ng-template>

    <ng-template matTabContent>
      <app-assignment-edit [roster]="roster"></app-assignment-edit>
    </ng-template>
  </mat-tab>

  <mat-tab label="Non Working Days">
    <ng-template mat-tab-label>
      Non Working Days
    </ng-template>

    <ng-template matTabContent>
      <app-non-working-day-list [roster]="roster"></app-non-working-day-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Run History">
    <ng-template mat-tab-label>
      Run History
    </ng-template>

    <ng-template matTabContent>
      <app-run-history-view-grid [roster]="roster"></app-run-history-view-grid>
    </ng-template>
  </mat-tab>

</mat-tab-group>